import api from './api';

export default {
  upload(files, path) {
    const data = new FormData();
    data.append('path', path);
    data.append('image', files[0]);

    return new Promise((resolve, reject) => {
      api
        .post('image', data, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  }
};
